import * as React from "react";
import Social from "src/components/Navigation/Social";
import NavigationContainer from "src/containers/NavigationContainer";
import { Colors, ISideDrawerComponent } from "src/ScrollyInterface";
import Backdrop from "src/UI/Backdrop";
import "./SideDrawer.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const sideDrawer = (props: ISideDrawerComponent) => {
  const { closed, links, open, navImages, navType } = props;
  const style = open
    ? {
        transform: "translate(0px, 0px) translateZ(0px)",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0.1, 0.57, 0.1, 1)"
      }
    : {
        transform: "translateX(100%)",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0.1, 0.57, 0.1, 1)"
      };

  return (
    <div className="SideDrawer-container" style={style}>
      <Backdrop show={open} clicked={closed} />
      <div className="SideDrawer">
        <div className="SideDrawer-backdrop-content" onClick={closed}>
          <div className="SideDrawer-close-container">
            <FontAwesomeIcon icon="times" className="SideDrawer-close" />
          </div>
          <div className="SideDrawer-social">
            <Social color={Colors.white} links={links} navType={navType} />
          </div>
        </div>
        <NavigationContainer navImages={navImages} navType={navType} />
      </div>
    </div>
  );
};

export default sideDrawer;



// WEBPACK FOOTER //
// ./src/components/Navigation/SideDrawer.tsx